export enum Parking {
  SAME = "Same as residential address",
  DIFFERENT = "Not same as residential address",
  ROAMING = "Roaming",
}
